<div class="w-full bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-5 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Control de Inventario</h2>
      <p class="text-500 m-0">Reabastecimiento por tallas.</p>
    </div>
    <span class="p-input-icon-left w-full md:w-auto">
            <input pInputText type="text" placeholder="Buscar producto..." class="w-full md:w-20rem border-round-3xl" />
        </span>
  </div>

  <p-table [value]="products" [rows]="10" [paginator]="true" styleClass="p-datatable-sm shadow-1 border-round">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5rem">Img</th>
        <th pSortableColumn="name">Producto <p-sortIcon field="name"></p-sortIcon></th>
        <th>Color</th>
        <th pSortableColumn="stock" class="text-center">Stock Total <p-sortIcon field="stock"></p-sortIcon></th>
        <th class="text-center">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product>
      <tr class="text-sm">
        <td><img [src]="product.image" class="w-3rem border-round shadow-1" /></td>
        <td>
          <span class="font-bold block">{{ product.name }}</span>
          <span class="text-xs text-500">{{ product.sku }}</span>
        </td>
        <td>
          <div class="flex align-items-center gap-2" *ngIf="product.color">
            <div class="w-1rem h-1rem border-circle border-1 border-300" [style.background-color]="product.color"></div>
            <span class="text-xs">{{ product.colorName }}</span>
          </div>
        </td>
        <td class="text-center">
          <p-tag [value]="product.stock + ' u.'" [severity]="getStockSeverity(product.stock)"></p-tag>
        </td>
        <td class="text-center">
          <button pButton label="Gestionar" icon="pi pi-box"
                  class="p-button-outlined p-button-sm p-button-rounded"
                  (click)="openManageStock(product)">
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="stockDialogVisible"
          [modal]="true"
          [style]="{width: '500px'}"
          [draggable]="false"
          [resizable]="false"
          header="Gestión de Stock">

  <div *ngIf="selectedProduct" class="pt-2">

    <div class="flex align-items-center gap-3 mb-4 p-3 bg-blue-50 border-round">
      <img [src]="selectedProduct.image" class="w-4rem border-round bg-white shadow-1">
      <div>
        <h3 class="m-0 text-lg text-900">{{ selectedProduct.name }}</h3>
        <span class="text-sm text-600">Total Actual: <b>{{ selectedProduct.stock }} unid.</b></span>
      </div>
    </div>

    <p class="mb-3 font-bold text-sm text-gray-500 uppercase tracking-wide">Desglose por Tallas</p>

    <div class="flex flex-column gap-3">
      <div *ngFor="let detail of selectedProduct.stockDetails"
           class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round hover:surface-50 transition-colors">

        <div class="flex align-items-center gap-3" style="width: 40%;">
          <div class="w-3rem h-3rem bg-gray-900 text-white border-circle flex align-items-center justify-content-center font-bold text-lg">
            {{ detail.sizeName }}
          </div>
          <div class="flex flex-column">
            <span class="text-xs text-500">Stock Actual</span>
            <span class="font-bold text-lg" [ngClass]="{'text-red-500': detail.quantity === 0, 'text-green-600': detail.quantity > 5}">
                            {{ detail.quantity }} u.
                        </span>
          </div>
        </div>

        <div class="flex align-items-center gap-2" style="width: 60%; justify-content: flex-end;">
          <span class="text-xl font-bold text-gray-400">+</span>

          <p-inputNumber
            [(ngModel)]="tempAddValues[detail.sizeId]"
            placeholder="0"
            [min]="0"
            [showButtons]="true"
            buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            inputStyleClass="w-3rem text-center p-0 font-bold"
            class="custom-stock-input">
          </p-inputNumber>

          <button pButton icon="pi pi-check"
                  class="p-button-rounded p-button-success shadow-1"
                  pTooltip="Guardar cambios"
                  (click)="addStock(detail)"
                  [disabled]="!tempAddValues[detail.sizeId] || tempAddValues[detail.sizeId]! <= 0">
          </button>
        </div>

      </div>
    </div>

  </div>
</p-dialog>
